import * as React from 'react';
import { useState, useEffect } from "react";
import QuoteDetail from '@system/config/quote-detail';
import Helper from 'src/support/Helper';
import { useQuoteStore } from "../../hooks/quote";
import { Pagination } from 'src/reusable/global';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import NoResultContent from '../HomePageContent/NoResultContent';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import Constants from 'src/support/Constants';
import produceClone from 'src/helper/produceClone';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import System from 'src/helper/system';
import liveAuth from "src/helper/liveAuth";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

// DT-CR-8419 - reset column as per Figma
// 9120 - add Currency column (with symbol)
// DT - quotesource = null then display "--"
// 9252: Quote dashboard / Submitted quote 
// 9607 - DT - 7March - Provisional quote number in quotes search result

export function SubmittedQuoteList() {
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();
    const [{ submittedQuoteList, quoteReasonList }, { fetch_submitted_quote_list, fetch_submitted_quote_export_url, get_quote_reason_list }, { }] = useQuoteStore()
    const [list, setList] = useState([]);
    const [headerDistance, setHeaderDistance] = useState(0);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
    });
    const setPageLimit = async (event) => {
        setListObj({ ...listObj, page: 1, limit: event.target.value });
    }


        useEffect(() => {
            window.scrollTo({ top: 0 });
        }, [list])

        useEffect(() => {
            async function fetchHere() {
                setFirstServerCall(false)
                fetchAPICall()
            }
            fetchHere();
        }, [listObj.page, listObj.limit, listObj.sortBy, listObj.sortOrder]);

        useEffect(() => {
            if (submittedQuoteList && Object.keys(submittedQuoteList).length > 0) {
                const data = submittedQuoteList;
                const total = data.count;
                setList(submittedQuoteList.records)
                setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
            }
            if (firstServerCall === false && liveAuth.check() && !monitorFunctionCall) {
                Helper.monitorJSDx()
                setMonitorFunctionCall(true)
            }
        }, [submittedQuoteList]);

        const getReason = (id) => {
            if (id.trim()) {
                const _res = quoteReasonList?.find(f => f.quoteReasonType === id)?.quoteReasonName;
                return _res ? _res : "";
            }
            else return '';
        }

        const fetchAPICall = async () => {
            await fetch_submitted_quote_list({
                "pageNumber": listObj.page,
                "pageSize": listObj.limit,
                "sortBy": listObj.sortBy,
                "sortType": listObj.sortOrder
            })
        };

        const manageLoad = (loadVal, quoteNumber) => {
            let _cloneObject = produceClone(list);
            let newList = _cloneObject.map((item) => {
                if (item.quoteNumber === quoteNumber) {
                    const updatedItem = {
                        ...item,
                        isLoad: loadVal,
                    };
                    return updatedItem;
                }
                return item;
            });
            setList(newList);
        }
        const onSelectOption = async (e, ele) => {
            if (e.target.value != '') {
                manageLoad(true, ele.quoteNumber)
                let result = await fetch_submitted_quote_export_url({ "quoteNumber": ele.quoteNumber, "provisionalId": ele.quoteProvisionalNumber, "fileType": e.target.value })
                if (result?.size > 0 && result?.type) {
                    showDownloadMessage();
                    exportEvent(result?.type, ele)

                }
                manageLoad(false, ele.quoteNumber)
            }
        };


        /** Bug: 9670 : Display download message on download : PN : 4 Aug 2023 */
        const showDownloadMessage = () => {
            System.alert(Constants.downloadMsg, 'success')
        }

        //By Ramya [Export Event - Cart ADobe script]
        function exportEvent(type, quote) {
            localStorage.setItem("adobeEventType", "exportEvent");
            let exportDetails = {
                fileExtension: type,
                exportType: "Quote"
            }
            let QuoteDetails = {
                quoteID: quote.quoteNumber,
                quoteType: quote.quoteSource
            };
            if (Object.keys(exportDetails).length && Object.keys(QuoteDetails).length) {
                HelperAdobeEvent.trackingAdobeEvent({ QuoteDetails, exportDetails });
            }

        }

        const handlePageClick = async (data) => {
            let here_page = 0
            here_page = data.selected + 1;
            setListObj({ ...listObj, page: here_page })
            Helper.scrollTop();
        };

        const toggleOrderBy = async (columnName) => {
            if (listObj.ascDesField.hasOwnProperty(columnName)) {
                listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
                setListObj({ ...listObj, ascDesField: listObj.ascDesField})
               
            } else {
                listObj.ascDesField[columnName] = 'ASC'
                setListObj({ ...listObj, ascDesField: listObj.ascDesField})
    
            }
            setListObj({ ...listObj, sortBy: columnName,sortOrder:listObj.ascDesField[columnName] })    
        };

        const getOrderByClass = (columnName) => {
            if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
                return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
            }
            return 'sorting'
        };

        useEffect(() => {
            const handleScroll = () => {
                //   const tableHeader = document.getElementById('yourTableHeaderId');
                //   const tableHeader =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
                const tableHeader = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight - 1 : 65 + 1
                console.log('tableHeader', tableHeader)
                if (tableHeader) {
                    // const rect = tableHeader.getBoundingClientRect();

                    // const top = tableHeader[0].offsetTop
                    setHeaderDistance(tableHeader);
                }
            };

            window.addEventListener('scroll', handleScroll);

            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }, []);

        return (
            <>
                {_check_p('QT_VIEW').status &&
                    <>
                        {list && list.length > 0 || __check(['QUOTE_API_CALL']).status ?
                            <div className='position-relative mx-3'>
                                <div>
                                    {__check(['QUOTE_API_CALL'], { overlay: true }).render}
                                </div>
                                <div className="submitted-quote-table mb-5">
                                    <div className="sticky-table-wrapper">
                                        <table className="bs5 table table-bordered table-striped">
                                            <thead style={{ position: 'sticky', top: headerDistance, zIndex: '999' }}>
                                                <tr>
                                                    <th className='w155'></th>
                                                    <th><span>Web Quote Number</span>
                                                        <span aria-label='quoteprovisionalnumber' className={'sort-container ' + getOrderByClass('quoteprovisionalnumber')}>
                                                        </span>
                                                    </th>

                                                    <th><span>Quote Number</span>
                                                        <span aria-label='quotenumber' className={'sort-container ' + getOrderByClass('quotenumber')}
                                                            onClick={async () => { await toggleOrderBy('quotenumber') }}></span>
                                                    </th>

                                                    <th><span>Date Requested</span>
                                                        <span aria-label='quoterequesteddate' className={'sort-container ' + getOrderByClass('quoterequesteddate')}
                                                            onClick={async () => { await toggleOrderBy('quoterequesteddate') }}></span>
                                                    </th>
                                                    <th><span>Expiration</span>
                                                        <span aria-label='quoteexpirydate' className={'sort-container ' + getOrderByClass('quoteexpirydate')}
                                                            onClick={async () => { await toggleOrderBy('quoteexpirydate') }}></span>
                                                    </th>
                                                    <th><span>Order Type</span>
                                                        <span aria-label='quotesource' className={'sort-container ' + getOrderByClass('quotesource')}>
                                                        </span>
                                                    </th>
                                                    <th><span>Buyer</span>
                                                        <span aria-label='contactname' className={'sort-container ' + getOrderByClass('contactname')}
                                                            onClick={async () => { await toggleOrderBy('contactname') }}></span>
                                                    </th>
                                                    <th><span>Quote Reference</span>
                                                        <span aria-label='quotereferencenumber' className={'sort-container ' + getOrderByClass('quotereferencenumber')}
                                                            onClick={async () => { await toggleOrderBy('quotereferencenumber') }}></span>
                                                    </th>
                                                    <th><span>Currency</span>
                                                        <span aria-label='quotecurrency' className={'sort-container ' + getOrderByClass('quotecurrency')}
                                                            onClick={async () => { await toggleOrderBy('quotecurrency') }}></span>
                                                    </th>
                                                    <th><span>Quote Reason</span>
                                                        <span aria-label='quotereason' className={'sort-container ' + getOrderByClass('quotereason')}
                                                            onClick={async () => { await toggleOrderBy('quotereason') }}></span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list && list.length > 0 && list.map((v, i) => (
                                                    <React.Fragment key={i}>
                                                        <tr>
                                                            <td>
                                                                {v.quoteNumber?.trim() ?
                                                                    <div className="dropdown">
                                                                        {v.isLoad &&
                                                                            <AxiosIndicatorRunTimeLoader />
                                                                        }
                                                                        {v.isLoad === false &&
                                                                            <div className="selectbox">
                                                                                <select className="form-control form-control-sm" key={v.quoteNumber}
                                                                                    onChange={(e) => onSelectOption(e, v)}>
                                                                                    <option value=''>Option</option>
                                                                                    <option value='xlsx'>Export XLSX</option>
                                                                                    <option value='csv'>Export CSV</option>
                                                                                </select>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    : <div className='text-center'>——</div>}
                                                            </td>

                                                            <td>
                                                                {/** 9244 : When redirecting through provisional number than quote number will always remain blank so removed that part : Pankaj : 22 Feb 2023  */}
                                                                {v.quoteProvisionalNumber?.trim() ? <a href={QuoteDetail.getQuoteDetailPageRouteURL({
                                                                    quoteProvisionalNumber: v.quoteProvisionalNumber,
                                                                    __c_QuoteDetailTabList: "PND"
                                                                })}> {v.quoteProvisionalNumber}</a>
                                                                    : v.quoteSource === 'offline' ? Constants.noValue : " Pending"}
                                                            </td>

                                                            <td>
                                                                {v.quoteNumber?.trim() ? <a href={QuoteDetail.getQuoteDetailPageRouteURL({
                                                                    quote_number: v.quoteNumber,
                                                                    quoteProvisionalNumber: v.quoteProvisionalNumber
                                                                })}> {v.quoteNumber}</a>
                                                                    : "In Process"}
                                                            </td>
                                                            <td>{(v.quoteRequestedDate && v.quoteRequestedDate !== "00000000") ? Helper.dateFormatFromString(v.quoteRequestedDate) : Constants.noValue}</td>
                                                            <td>{v.quoteExpirationDate && v.quoteExpirationDate !== "00000000" ? Helper.dateFormatFromString(v.quoteExpirationDate) : Constants.noValue}</td>
                                                            <td>
                                                                {(v.quoteSource && v.quoteSource.trim()) ? v.quoteSource : Constants.noValue}</td>
                                                            <td>{(v.contactName != null && v.contactName.trim()) ? v.contactName : Constants.noValue}</td>
                                                            <td>{Helper.valueIsNotNull(v.quoteReferenceNumber) ? v.quoteReferenceNumber : Constants.noValue}</td>
                                                            <td>{Helper.valueIsNotNull(v.quoteCurrency) ?
                                                                <span>{getSymbolFromCurrency(v.quoteCurrency)} {v.quoteCurrency} </span>
                                                                : Constants.noValue}</td>
                                                            <td>{getReason(v.quoteReasonType)}</td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                            </div>
                            : <NoResultContent message={"Sorry! We can't find any results"} isDisplay={false} />
                        }
                    </>
                }
            </>
        );

    }
